import $ from 'jquery';
import moment from 'moment';
import 'bootstrap';
import bootbox from 'bootbox';

window.addEventListener('vite:preloadError', (event) => {
    event.preventDefault();
    const reloadKey = 'vite_preload_reload';
    if (!sessionStorage.getItem(reloadKey)) {
        sessionStorage.setItem(reloadKey, '1');
        window.location.reload();
    }
});

window.addEventListener('unhandledrejection', (event) => {
    const msg = event?.reason?.message ?? '';
    if (
        msg.includes('Failed to fetch dynamically imported module') ||
        msg.includes('error loading dynamically imported module') ||
        msg.includes('Importing a module script failed') ||
        msg.includes('Unable to preload') ||
        msg.includes('Vue component at')
    ) {
        event.preventDefault();
        const reloadKey = 'vite_chunk_reload';
        if (!sessionStorage.getItem(reloadKey)) {
            sessionStorage.setItem(reloadKey, '1');
            window.location.reload();
        }
    }
    if (msg === 'validation_error') {
        event.preventDefault();
    }
});

if (process.env.NODE_ENV === 'production') {
    import('resources/assets/js/infrastructure/sentry.js')
}

import './system.js';

window.$ = $;
window.jQuery = $;
window.moment = moment;
window.bootbox = bootbox;

// Import jQuery plugins
import Fancybox from 'fancybox';
import 'typeahead.js';
import * as Select2 from 'select2';
Fancybox($);

import mountVueApp from 'Common/Logical/MountVueApp.js';
import {reset} from 'Common/Logical/BurningCrusade.js';

window.mountVueApp = mountVueApp;
window.dispatchEvent(new Event('mount-vue-app-ready'));
reset();

/***********************************************************************************************************************
 * Import section
 * In the old JS setup, it knew to read all JS files and automatically include and run them. I couldn't figure it out in
 * Vite, so I'm importing all the JS files here.
 **********************************************************************************************************************/

import 'resources/assets/js/site_types/afri.js';
import 'resources/assets/js/site_types/cobre.js';
import 'resources/assets/js/site_types/ctr.js';
import 'resources/assets/js/site_types/epscor.js';
import 'resources/assets/js/site_types/ftf.js';
import 'resources/assets/js/site_types/inbre.js';
import 'resources/assets/js/site_types/nist.js';
